<template>
  <div class="segmented-control">
    <div
        class="segmented-control-slider"
        :style="sliderStyle"
    ></div>
    <button
        v-for="(option, index) in options"
        :key="option.value"
        class="segmented-control-option"
        :class="{ active: modelValue === option.value }"
        @click="$emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  options: {
    type: Array,
    required: true
  },
  modelValue: {
    type: [String, Number],
    default: null
  }
})

defineEmits(['update:modelValue'])

const activeIndex = computed(() =>
    props.options.findIndex(o => o.value === props.modelValue)
)

const sliderStyle = computed(() => {
  const width = 100 / props.options.length
  return {
    width: `${width}%`,
    transform: `translateX(${activeIndex.value * 100}%)`,
    opacity: activeIndex.value >= 0 ? 1 : 0
  }
})
</script>

<style scoped>
.segmented-control {
  display: flex;
  position: relative;
  background-color: rgba(var(--tblr-body-color-rgb), 0.08);
  border-radius: 8px;
  padding: 3px;
}

.segmented-control-slider {
  position: absolute;
  top: 3px;
  left: 3px;
  height: calc(100% - 6px);
  background-color: var(--tblr-primary);
  border-radius: 6px;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;
  z-index: 0;
}

.segmented-control-option {
  flex: 1;
  position: relative;
  z-index: 1;
  padding: 8px 16px;
  border: none;
  background: none;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--tblr-body-color);
  cursor: pointer;
  transition: color 0.2s ease;
  border-radius: 6px;
}

.segmented-control-option.active {
  color: white;
}

.segmented-control-option:focus-visible {
  outline: 2px solid var(--tblr-primary);
  outline-offset: 2px;
}
</style>
